import axios from 'axios';

export function getContracts() {
    return axios({
        method: 'GET',
        url: '/api/v1/contracts/voyage/names',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getTimeContracts() {
    return axios({
        method: 'GET',
        url: '/api/v1/contracts/time/names',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}



// WEBPACK FOOTER //
// ./app/services/contracts.js